import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import AdsWrapper from '../AdsWrapper'
import ItemsLoading from '../../../../../../components/Loaders/ItemsLoading'
import AdCardListItem from '../../../../../../features/components/AdCardListItem'
import GoogleAdSkeleton from './GoogleAdSkeleton'
import GoogleAdImageType from '../../../../../../forms/Google/AdForms/GoogleAssetsSliderPreview/Previews/GoogleAdImageType'
import GoogleAdPreviewDiscover1 from '../../../../../../forms/Google/AdForms/GoogleAssetsSliderPreview/Previews/GoogleAdPreviewDiscover1'

import { getAdGoogleTransformedValues } from '../../../../../../forms/Google/AdForms/AdGoogleEdit/helpers'
import { useSortAds } from '../hooks'

import {
  combinedAdsErrorSelector,
  combinedAdsIsLoadingSelector,
  combinedAdsSelector,
  combinedAdsWasLoadedSelector
} from '../../../../../../modules/selectors/combinedData'

import { GOOGLE_PROVIDER_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import {
  FILE_URL,
  LANDSCAPE_IMAGE,
  landscapeImageHeight,
  landscapeImageWidth
} from '../../../../../../forms/Google/AdForms/fields'

import useStyles from './styles'

const GoogleHighestPerformingAds = () => {
  const classes = useStyles(260)

  const combinedAds = useSelector(combinedAdsSelector)

  const googleAds = useMemo(() => {
    return combinedAds.filter(ad => ad.provider === GOOGLE_PROVIDER_PLATFORM)
  }, [combinedAds])

  const sortedGoogleAds = useSortAds(googleAds)

  const renderedAdsListCards = useMemo(() => {
    return sortedGoogleAds.map(ad => {
      const transformedAdValues = getAdGoogleTransformedValues(ad)

      return (
        <AdCardListItem>
          {
            // todo refactor to switch case and ad data transformation when this type of ad will be supported
            ad.ad?.type === 'IMAGE_AD' ? (
              <GoogleAdImageType adData={ad} />
            ) : (
              <GoogleAdPreviewDiscover1
                values={transformedAdValues}
                fileUrl={transformedAdValues[LANDSCAPE_IMAGE][0]?.[FILE_URL]}
                width={landscapeImageWidth}
                height={landscapeImageHeight}
              />
            )
          }
        </AdCardListItem>
      )
    })
  }, [sortedGoogleAds])

  return (
    <section id="google-ad-cards-list">
      <ItemsLoading
        itemsLength={sortedGoogleAds.length}
        className={classes.cardsList}
        noDataText={'There are no highest performing Google ads'}
        isLoadingSelector={combinedAdsIsLoadingSelector}
        wasLoadedSelector={combinedAdsWasLoadedSelector}
        errorSelector={combinedAdsErrorSelector}
        initialLoadingSkeletonsNumber={5}
        SkeletonComponent={GoogleAdSkeleton}
        ContentWrapper={AdsWrapper}
      >
        {renderedAdsListCards}
      </ItemsLoading>
    </section>
  )
}

export default GoogleHighestPerformingAds
